import ComponentLayout from "../../../../src/layouts/component-layout";
import header from "../../../../content/components/Button/images/button_header.png";
import buttonAccent from "../../../../content/components/Button/images/button_accent.png";
import * as React from 'react';
export default {
  ComponentLayout,
  header,
  buttonAccent,
  React
};